var _componentMaxlength = function($context) {
    if (!$().maxlength) {
        console.warn('Warning - maxlength.min.js is not loaded.');
        return;
    }

    // Basic example
    ($context instanceof jQuery ? $context.find('.js-maxlength') : $('.js-maxlength')).each(function() {
        var $me = $(this);

        $me.maxlength({
            alwaysShow: true,
            showOnReady: true,
            appendToParent: true,
            allowOverMax: true,
            customMaxAttribute: $me.data('maxlength')
        });
    });      
};

function init($context) {
    _componentMaxlength($context);
}


export const ExtendedFormControls = {
    init
}